import React from "react";
import { useLocalStorage } from "./useLocalStorage";

const TodoContext = React.createContext();
const defaultTodos = [
  {
    text: "Crea custom hooks para el manejo de eventos y almacenamiento.",
    completed: false,
  },
  {
    text: "Maneja estados locales con React Hooks y globales con React Context.",
    completed: true,
  },
  {
    text: "Analiza las diferencias entre Create React App, Vite.js y Next.js",
    completed: false,
  },
];
// localStorage.removeItem("TODOS_V1")
// JSON.parse(localStorage.getItem("TODOS_V1"))

function TodoProvider({ children }) {
  // ESTADOS
  const {
    item: todos,
    saveItem: saveTodos,
    loading,
    error,
  } = useLocalStorage("TODOS_V1", defaultTodos);
  const [searchValue, setSearchValue] = React.useState(""); // tareas filtradas
  const [darkMode, setDarkMode] = React.useState(true);
  const [openModal, setOpenModal] = React.useState(false);

  const completedTodos = todos.filter((todo) => !!todo.completed).length; // == true
  const totalTodos = todos.length;
  const allTodos = todos;

  let searchedTodos = [];

  if (!searchValue.length >= 1) {
    // no hay texto en la busqueda
    searchedTodos = todos;
  } else {
    // buscar un patron
    searchedTodos = todos.filter((todo) => {
      const todoText = todo.text.toLowerCase();
      const searchText = searchValue.toLowerCase();
      return todoText.includes(searchText);
    });
  }

  // FUNCIONES
  const completeTodo = (text) => {
    const todoIndex = todos.findIndex((todo) => todo.text === text);
    const newItem = [...todos];
    todos[todoIndex].completed = !todos[todoIndex].completed; // actualizar tarea seleccionada
    saveTodos(newItem);
  };

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  const deleteTodo = (text) => {
    const todoIndex = todos.findIndex((todo) => todo.text === text);
    const newItem = [...todos];
    newItem.splice(todoIndex, 1); // eliminar tarea seleccionada
    saveTodos(newItem);
  };

  const addTodo = (text) => {
    const newItem = [...todos];
    newItem.push({ text, completed: false });
    saveTodos(newItem);
  };

  return (
    <TodoContext.Provider
      value={{
        loading,
        error,
        totalTodos,
        completedTodos,
        searchValue,
        setSearchValue,
        searchedTodos,
        allTodos,
        completeTodo,
        deleteTodo,
        addTodo,
        toggleDarkMode,
        darkMode,
        openModal,
        setOpenModal,
      }}
    >
      {children}
    </TodoContext.Provider>
  );
}

export { TodoContext, TodoProvider };
